import { Platform } from "react-native"
import { wsChat, wsError, wsState } from "./mainSlice";

/**
 * Creates a websocket connection to the backend server
 */
export const websocket = store => {
    let ws
    let syncInterval = null
    let lastPing = Date.now()

    const begPing = (ws) => {
        console.ina("BEG Ping")
        lastPing = Date.now()
        ws.send('ping')
        if (null == syncInterval) {
            syncInterval = setInterval(() => {
                if (ws?.send) {
                    lastPing = Date.now()
                    ws.send('ping')
                }
            }, 59000)
        } else {
            console.ina('SKIP PING')
        }
    }

    const endPing = () => {
        if (syncInterval) {
            console.ina("END Ping")
            clearInterval(syncInterval)
            syncInterval = null
        }
    }

    return next => action => {
        // console.ina('WS ACT', action);
        if (false && action.type === 'main/wsConnect' && store.getState().user.mail.endsWith('@ina.coach')) {
            console.log('WS CON', 'trying to connect.....')
            ws = new WebSocket((Platform.OS === 'web' ? store.getState().server.url.replace(/^http/, 'ws') : store.getState().server.url) + '/chat')

            ws.onopen = () => {
                console.ina('WS CON', store.getState().server.ws.id)
                store.dispatch(wsState({ connected: true, ws: ws }))
                begPing(ws)
            }
            ws.onclose = (e) => {
                // console.ina('XCLS', Object.keys(e))
                console.ina('WS DIS', store.getState().server.ws.id, e)
                store.dispatch(wsState({ connected: false }))
                endPing(ws)
            }
            ws.onerror = (e) => {
                // console.ina('XERR', Object.keys(e))
                console.ina('WS ERR', store.getState().server.ws.id, e)
                store.dispatch(wsError({ error: e.message }))
            }
            ws.onmessage = (message) => {
                // console.ina('XMSG', Object.keys(e))
                console.ina("WS MSG: ", message)
                if (message.data === 'pong') {
                    console.ina('PONG', Date.now() - lastPing)
                } else {
                    console.ina('WS MSG', store.getState().server.ws.id, message)
                    const msg = JSON.parse(message.data)
                    console.log(msg)
                    if (msg.fromUserId && msg.message) {
                        store.dispatch(wsChat({ chatMsg: msg }))
                    }
                    /*switch (msg.type) {
                        case 'AUTH':
                            store.dispatch(backendLogin('LOGIN', msg.data))
                            break;
                        case 'CHAT':
                        case 'TEST':
                            store.dispatch(wsChat(msg.data))
                            break;
                        default:
                            console.ina('UNKOWN')
                    }*/
                }
            }
        }

        if (action.type === 'main/wsSend') {
            const server = store.getState().server
            if (server.ws?.connected) {
                if (ws?.send) {
                    console.ina('WS SEND', action)
                    ws.send(JSON.stringify(action.payload.msg))
                } else {
                    console.ina('WS SKIP', action)
                }
            }
        }

        next(action)
    }
}
